import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCareer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 27,
	viewBox: "0 0 32 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 13L16 26M9.99989 22H10.0499M22.9999 25H23.0499M18.9999 3H19.0499M31 7.49208C22.4457 5.05096 15.2221 12.081 16.0674 20C28.3369 19.4998 25.7192 11.1134 31 7.49208ZM1 1.16351C10.6893 -0.309416 17.649 8.42658 15.6591 17C2.2996 14.7201 6.29196 5.88359 1 1.16351Z",
		stroke: "#7FE718",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCareer;
